










import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {}
})
export default class XLine extends Vue {
  @Prop({
    default: {}
  })
  public config!: any;

  @Prop({
    default: {
      value: 0,
      label: false,
      bold: false
    }
  })
  public line!: any;

  public fillStyleForXLine(line: any) {
    return {
      left: (((line.value - this.config.xOffset) / this.config.xLength) * 100) + '%'
    }
  }

}
